(function () {
  'use strict';

  const PRICE_FIELD = 'contact[filter.v.price.gte , filter.v.price.lte]';
  const LEVEL_FIELD = 'contact[filter.p.m.dartfinder.niveau]';
  const TUNGSTEN_FIELD = 'contact[filter.p.m.dartfinder.tungsten]';
  const FINDER_GRIP_FIELD = 'contact[filter.p.m.dartfinder.grip]';
  const LENGTH_FIELD = 'contact[filter.p.m.custom.length]';
  const GRIP_LEVEL_FIELD = 'contact[filter.p.m.custom.grip_level]';

  const ADVANCED_STEPS = new Set([8, 2, 3, 4, 5, 9]);
  const BEGINNER_BASE_STEPS = new Set([6]);

  const OUTPUT_ALIASES = {
    'filter.p.m.custom.material_barrel': 'filter.p.m.custom.filter_material',
    'filter.p.m.custom.barrelform_liste': 'filter.p.m.custom.filter_form',
    'filter.p.m.custom.wechselspitzen_system': 'filter.p.m.custom.filter_spitzensystem',
    'filter.p.m.custom.length': 'filter.p.m.custom.filter_laenge'
  };

  const ADVANCED_PROGRESS = {1:1,8:2,2:3,3:4,4:5,5:6,9:7};
  const BEGINNER_PROGRESS = {1:1,6:2,7:3};
  const histories = new WeakMap();

  function getForm(element) { return element && element.closest ? element.closest('form') : null; }
  function getWrappers(form) { return form ? Array.from(form.querySelectorAll('.form-input-wapper')) : []; }
  function getTechnicalStep(wrapper, wrappers) {
    if (!wrapper) return 0;
    const stepClass = Array.from(wrapper.classList).find((name) => /^step-\d+$/.test(name));
    if (stepClass) return Number(stepClass.replace('step-', ''));
    const index = wrappers.indexOf(wrapper);
    return index >= 0 ? index + 1 : 0;
  }
  function getHistory(form) { if (!histories.has(form)) histories.set(form, []); return histories.get(form); }
  function resetHistory(form) { histories.set(form, []); try { localStorage.removeItem('stepNumber'); } catch (error) {} }
  function getCheckedInput(form, name) { return form ? Array.from(form.querySelectorAll('input:checked')).find((input) => input.name === name) || null : null; }
  function getSelectedPath(form) {
    const selected = getCheckedInput(form, LEVEL_FIELD);
    if (!selected) return null;
    const next = Number(selected.dataset.step || 0);
    if (next === 8) return 'advanced';
    if (next === 6) return 'beginner';
    return null;
  }
  function isLowPriceSelected(form) {
    const selected = getCheckedInput(form, PRICE_FIELD);
    if (!selected) return false;
    const value = String(selected.value || '').trim().replace(',', '.');
    const parts = value.split(/[–-]/).map((part) => part.trim());
    if (parts.length < 2) return false;
    const min = Number(parts[0]);
    const max = Number(parts[1]);
    return Number.isFinite(min) && Number.isFinite(max) && min <= 0 && max <= 50;
  }
  function allowedSteps(form) {
    const path = getSelectedPath(form);
    if (path === 'advanced') return new Set(ADVANCED_STEPS);
    if (path === 'beginner') {
      const allowed = new Set(BEGINNER_BASE_STEPS);
      if (isLowPriceSelected(form)) allowed.add(7);
      return allowed;
    }
    return new Set();
  }
  function clearOtherRouteAnswers(form) {
    const wrappers = getWrappers(form);
    wrappers.forEach((wrapper) => {
      const step = getTechnicalStep(wrapper, wrappers);
      if (step === 1) return;
      wrapper.querySelectorAll('input').forEach((input) => {
        if (input.type === 'radio' || input.type === 'checkbox') input.checked = false;
      });
    });
    resetHistory(form);
  }
  function setButton(button, mode, nextStep) {
    if (!button) return;
    if (mode === 'submit') {
      button.type = 'submit';
      button.removeAttribute('data-next-step');
      button.removeAttribute('onclick');
      button.disabled = false;
      return;
    }
    button.type = 'button';
    button.removeAttribute('onclick');
    if (nextStep) button.dataset.nextStep = String(nextStep); else button.removeAttribute('data-next-step');
    button.disabled = false;
  }
  function expandRange(value) {
    const clean = String(value || '').trim().replace('–', '-');
    const match = clean.match(/^(\d+)\s*-\s*(\d+)$/);
    if (!match) return clean ? [clean] : [];
    const start = Number(match[1]);
    const end = Number(match[2]);
    if (!Number.isFinite(start) || !Number.isFinite(end) || start > end || end - start > 20) return [clean];
    const values = [];
    for (let number = start; number <= end; number += 1) values.push(String(number));
    return values;
  }
  function addGroupedValue(grouped, key, values) {
    if (!grouped.has(key)) grouped.set(key, []);
    const bucket = grouped.get(key);
    values.forEach((value) => {
      const clean = String(value || '').trim();
      if (clean && !bucket.includes(clean)) bucket.push(clean);
    });
  }
  function getVisibleTechnicalStep(form) {
    const wrappers = getWrappers(form);
    const visible = wrappers.find((wrapper) => {
      const style = window.getComputedStyle(wrapper);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
    return getTechnicalStep(visible, wrappers) || 1;
  }
  function progressState(form, technicalStep) {
    const path = getSelectedPath(form);
    if (path === 'advanced') return { current: ADVANCED_PROGRESS[technicalStep] || 1, total: 7 };
    if (path === 'beginner') {
      const total = isLowPriceSelected(form) ? 3 : 2;
      const current = BEGINNER_PROGRESS[technicalStep] || (technicalStep === 1 ? 1 : total);
      return { current: Math.min(current, total), total };
    }
    return { current: 1, total: 2 };
  }
  function updateLogicalProgress(form) {
    if (!form) return;
    const finder = form.closest('.dart-finder-wrp') || document;
    const progressText = finder.querySelector('.progress_count_wrp');
    if (!progressText) return;
    const state = progressState(form, getVisibleTechnicalStep(form));
    progressText.innerHTML = `${String(state.current).padStart(2, '0')} | ${String(state.total).padStart(2, '0')}`;
    progressText.style.width = `${(state.current / state.total) * 100}%`;
  }
  function showTechnicalStep(form, targetStep) {
    const wrappers = getWrappers(form);
    if (!wrappers.length) return;
    let found = false;
    wrappers.forEach((wrapper) => {
      const step = getTechnicalStep(wrapper, wrappers);
      const active = step === Number(targetStep);
      wrapper.style.display = active ? 'block' : 'none';
      if (active) found = true;
    });
    if (found) requestAnimationFrame(() => updateLogicalProgress(form));
  }
  function currentSelectedInput(wrapper) { return wrapper ? wrapper.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked') : null; }
  function configureNextButton(input) {
    if (!input) return;
    const form = getForm(input);
    const wrapper = input.closest('.form-input-wapper');
    const nextButton = wrapper && wrapper.querySelector('.next_btn');
    if (!form || !wrapper || !nextButton) return;
    const wrappers = getWrappers(form);
    const step = getTechnicalStep(wrapper, wrappers);
    if (input.name === LEVEL_FIELD) {
      clearOtherRouteAnswers(form);
      setButton(nextButton, 'next', input.dataset.step || null);
      updateLogicalProgress(form);
      return;
    }
    if (input.name === LENGTH_FIELD || step === 5) { setButton(nextButton, 'next', 9); return; }
    if (input.name === GRIP_LEVEL_FIELD || step === 9) { setButton(nextButton, 'submit'); return; }
    if (input.name === PRICE_FIELD || step === 6) {
      if (isLowPriceSelected(form)) setButton(nextButton, 'next', 7); else setButton(nextButton, 'submit');
      updateLogicalProgress(form);
      return;
    }
    if (input.dataset.submit === 'true') { setButton(nextButton, 'submit'); return; }
    if (input.dataset.step) { setButton(nextButton, 'next', input.dataset.step); return; }
    setButton(nextButton, 'next', null);
  }
  window.onInputChange = function (event, input) { configureNextButton(input || (event && event.target)); };
  function parsePrice(value, params) {
    const parts = String(value || '').trim().replace(',', '.').split(/[–-]/).map((part) => part.trim());
    if (!parts.length) return;
    let minPrice = parts[0] || '';
    let maxPrice = parts[1] || '';
    if (Number(minPrice) === 50 && Number(maxPrice) === 100) minPrice = '51';
    if (Number(minPrice) === 100 && !maxPrice) minPrice = '100.01';
    if (minPrice !== '') params.append('filter.v.price.gte', minPrice);
    if (maxPrice !== '') params.append('filter.v.price.lte', maxPrice);
  }
  function canonicalOutputKey(inputName) {
    const match = String(inputName || '').match(/^contact\[(.*)\]$/);
    if (!match || !match[1]) return '';
    return OUTPUT_ALIASES[match[1]] || match[1];
  }
  window.onSubmitFunction = function (event, button) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    const form = button && button.closest ? button.closest('form') : null;
    if (!form) return;
    const path = getSelectedPath(form);
    if (!path) return;
    const allowed = allowedSteps(form);
    const wrappers = getWrappers(form);
    const params = new URLSearchParams();
    const grouped = new Map();
    form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach((input) => {
      if (input.name === LEVEL_FIELD || !input.value) return;
      const wrapper = input.closest('.form-input-wapper');
      const step = getTechnicalStep(wrapper, wrappers);
      if (!allowed.has(step)) return;
      if (input.name === PRICE_FIELD) { parsePrice(input.value, params); return; }
      const key = canonicalOutputKey(input.name);
      if (!key) return;
      const values = input.name === GRIP_LEVEL_FIELD ? expandRange(input.value) : [input.value];
      addGroupedValue(grouped, key, values);
    });
    grouped.forEach((values, key) => { if (values.length) params.append(key, values.join(',')); });
    const collectionUrl = form.closest('.dart-finder-wrp')?.getAttribute('data-collection-url') || '/collections/steeldarts-1';
    const query = params.toString();
    window.location.href = query ? `${collectionUrl}?${query}` : collectionUrl;
  };
  function handleNextClick(event, button) {
    const form = getForm(button);
    const wrapper = button.closest('.form-input-wapper');
    if (!form || !wrapper || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.type === 'submit') { window.onSubmitFunction(event, button); return; }
    const selected = currentSelectedInput(wrapper);
    if (!selected) return;
    const wrappers = getWrappers(form);
    const currentStep = getTechnicalStep(wrapper, wrappers);
    let targetStep = Number(button.dataset.nextStep || 0);
    if (!targetStep) targetStep = currentStep + 1;
    const history = getHistory(form);
    if (history[history.length - 1] !== currentStep) history.push(currentStep);
    showTechnicalStep(form, targetStep);
  }
  function handlePreviousClick(event, button) {
    const form = getForm(button);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const history = getHistory(form);
    const current = getVisibleTechnicalStep(form);
    let target = history.length ? history.pop() : 0;
    if (!target && current > 1) target = current - 1;
    if (!target) target = 1;
    showTechnicalStep(form, target);
  }
  function initFinder(finder) {
    if (!finder || finder.dataset.dinoFinderFilterFixed === 'true') return;
    finder.dataset.dinoFinderFilterFixed = 'true';
    const form = finder.querySelector('form');
    if (!form) return;
    finder.querySelectorAll('[data-value-match]').forEach((element) => element.removeAttribute('data-value-match'));
    resetHistory(form);
    form.addEventListener('click', (event) => {
      const next = event.target.closest('.next_btn');
      if (next && form.contains(next)) { handleNextClick(event, next); return; }
      const previous = event.target.closest('.previous_btn');
      if (previous && form.contains(previous)) handlePreviousClick(event, previous);
    }, true);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = event.submitter || form.querySelector('.next_btn[type="submit"]');
      if (button) window.onSubmitFunction(event, button);
    }, true);
    form.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      configureNextButton(input);
    }, true);
    getWrappers(form).forEach((wrapper) => {
      const selected = currentSelectedInput(wrapper);
      if (selected) configureNextButton(selected);
    });
    requestAnimationFrame(() => updateLogicalProgress(form));
  }
  function init() { document.querySelectorAll('.dart-finder-wrp').forEach(initFinder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();